import React, { useState, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector, useDispatch } from 'react-redux';
import Tippy from '@tippyjs/react';
import 'tippy.js/dist/tippy.css';

const SEButtons = (props) => {
	const { t } = useTranslation();
	const dispatch = useDispatch();
	const optionFields = useSelector(state => state.optionFields);
	const hook_status = useSelector(state => state.pageData.hook_status);
	const preview = useSelector(state => state.pageData.preview);

	const {formFields} = props;
	const {funnel_page, num_se, form_components} = formFields;

	const curStep = useSelector(state => state.curStep);
	const fv = useSelector(state => state.fv);
	const nextStepValue = useSelector(state => state.nextStep) || curStep + 1;
	
	const [indicator, setIndicator] = useState('off');

	const progress_percent = curStep / formFields.num_se * 100;

	// Add a new selector to track jump history
	const jumpHistory = useSelector(state => state.jumpHistory) || [];

	const scrollToRegForm = () => {
		const regFormElement = document.getElementById('reg-form');
		if (regFormElement) {
			// Offset value equals the height of the top bar (52px).
			const yOffset = -52;
			const yCoordinate = regFormElement.getBoundingClientRect().top + window.scrollY + yOffset;
			window.scrollTo({ top: yCoordinate, behavior: 'smooth' });
		}
	};

	const prevStep = (e) => {
		// Prevent the default behavior and stop propagation so that other listeners don't act on this event.
		e.preventDefault();
		e.stopPropagation();

		if (curStep > 1) {
			console.log("jumpHistory", jumpHistory);
			if (jumpHistory && jumpHistory.length > 0) {
				// Find the last jump that led to current step
				const lastJump = jumpHistory.find(jump => jump.to === curStep);
				console.log('Last jump found:', lastJump);
				
				if (lastJump) {
					const originStep = lastJump.from;
					
					// Reset only the field that caused the jump
					const updatedOptionFields = optionFields.map(field => {
						if (field.fieldname === lastJump.fieldname) {
							// Clear DOM selection
							const formComponent = form_components.find(comp => 
								comp.fieldname === field.fieldname && 
								comp.format === 'IN'
							);
							
							if (formComponent?.input_type === 'radio') {
								$(`input[name="${field.fieldname}"]`).prop('checked', false);
							}
							
							return {
								...field,
								value: '',
								jump_to_session: null,
								jump_to_se_index: 0,
								jump_to_seq: 0
							};
						}
						return field;
					});

					// Get the next step from jump history
					let nextStepValue;
					if (jumpHistory.length > 0) {
						const latestJump = jumpHistory[jumpHistory.length - 1];
						nextStepValue = latestJump.to;
						console.log('Using latest jump to:', nextStepValue);
					} else {
						nextStepValue = originStep + 1;
						console.log('No jumps in history, going to:', nextStepValue);
					}

					// Update state in order, but keep the jump history
					dispatch({type: 'SET_OPTION_FIELDS', payload: updatedOptionFields});
					dispatch({type: 'SET_CUR_STEP', payload: originStep});
					dispatch({type: 'SET_NEXT_STEP', payload: nextStepValue});
				} else {
					const prev = curStep - 1;
					dispatch({type: 'SET_CUR_STEP', payload: prev});
					dispatch({type: 'SET_NEXT_STEP', payload: prev + 1});
				}
			} else {
				const prev = curStep - 1;
				dispatch({type: 'SET_CUR_STEP', payload: prev});
				dispatch({type: 'SET_NEXT_STEP', payload: prev + 1});
			}

			// Scroll to the form element
			scrollToRegForm();
		}
	};

	const nextStep = (e) => {
		e.preventDefault();

		fv.validate().then(async (status) => {
			console.log(`validated`, status, `curStep`, curStep, `nextStepValue`, nextStepValue, `num_se`, num_se);
			
			if (status === "Valid") {
				console.log("optionFields before check", optionFields);
				// New check: if any option field has jump_to_session equal to "submit_form", submit the form immediately.
				const submitField = optionFields.find(field => field.jump_to_session === "submit_form" && field.value);
				if (submitField) {
					console.log(`submitField detected with jump_to_session = submit_form`, submitField);
					submitForm();
					return;
				}

				if (curStep !== num_se) {
					// Check if we have any active jumps in optionFields
					const activeJump = optionFields.find(field => 
						field.jump_to_se_index === nextStepValue && 
						field.value
					);
					console.log(`activeJump`, activeJump);

					// If an active jump exists, record it in the jump history
					if (activeJump) {
						const newJumpHistory = [
							...jumpHistory,
							{
								from: curStep,
								to: nextStepValue,
								fieldname: activeJump.fieldname,
								value: activeJump.value,
								jump_to_session: activeJump.jump_to_session
							}
						];
						dispatch({ type: 'SET_JUMP_HISTORY', payload: newJumpHistory });
					}

					if (optionFields && optionFields.length > 0) {
						const updatedOptionFields = optionFields.map(field => ({
							...field,
							jump_to_session: field.jump_to_se_index === nextStepValue ? null : field.jump_to_session,
							jump_to_se_index: field.jump_to_se_index === nextStepValue ? 0 : field.jump_to_se_index,
							jump_to_seq: field.jump_to_se_index === nextStepValue ? 0 : field.jump_to_seq
						}));
						dispatch({ type: 'SET_OPTION_FIELDS', payload: updatedOptionFields });
					}

					dispatch({ type: 'SET_CUR_STEP', payload: nextStepValue });
					dispatch({ type: 'SET_NEXT_STEP', payload: nextStepValue + 1 });
				} else {
					submitForm();
				}
			} else {
				// If validation fails, you can perform any additional error handling here.
				console.error("Form validation failed.");
			}

			// In either case (Valid or failed), scroll to the registration form.
			scrollToRegForm();
		});
	};

	async function submitForm() {
		const form = document.getElementById('reg-form');
		const $submitButton = $("#nextButton");

		setIndicator('on');

		var rc = await checkForm($submitButton, form);
		console.log(`rc`, rc);

		if (!rc) {
			setIndicator('off');
		}
	}

	var tippyContent = '';
	switch (hook_status) {
		case 'warmup':
			tippyContent = t('活動即將開始');
			break;

		case 'expired':
			tippyContent = t('活動已結束');
			break;
	}

	return (
		<div className="survey-toolbar  d-flex px-3 align-items-center reset">
			{curStep > 1 && (
				<label
					className="btn btn-secondary"
					id="prevButton"
					onClick={prevStep}
				>
					{t('上一步')}
				</label>
			)}
			<div className="form-progress flex-grow-1 px-3">
		    	<div className="col ">
		        	<p className="text-gray-700 fz12 mb-0">{t('填寫進度：')}<span id="current-step" className="fw-bolder">{curStep}</span>/<span id="total-steps">{num_se}</span></p>
		    	</div>
		    
		    	<div className="progress mt-1 mw-200px mx-auto">
		        	<div
		        		id="progress-bar"
		        		className="progress-bar"
		        		role="progressbar"
		        		style={{width: `${progress_percent}%`}}
		        		aria-valuenow={curStep}
		        		aria-valuemin="0"
		        		aria-valuemax={num_se}
		        	/>
		    	</div>
		    </div>
		    <Tippy
		    	theme="primary"
		    	content={tippyContent}
		    	disabled={tippyContent === ''}
		    >
			    <span>
				    <button
				    	type={curStep === num_se ? 'submit' : 'button'}
				    	id="nextButton"
				    	className="btn btn-primary"
				    	data-kt-indicator={indicator}
				    	onClick={nextStep}
				    	disabled={hook_status !== 'live' || indicator === 'on' || preview}
				    >
				    	<span className="indicator-label">{curStep === num_se ? funnel_page.cta_text : t('下一步')}</span>
				    	<span className="indicator-progress">
				    		{t('請稍候...')}<span className="spinner-border spinner-border-sm align-middle ms-2"></span>
				    	</span>
				    </button>
			    </span>
			 </Tippy>
		</div>
	);
}

export default SEButtons;